﻿import { AnyElement, MuWidget } from "mu-widget/lib/MuWidget";

export class UiPrice extends MuWidget {
    //@ts-ignore
    container: HTMLInputElement;
    
    afterIndex(): void {
        this.container.style.textAlign = "right";
        this.container.maxLength = 16;
        this.container.classList.add("convertedNumber");
        if (this.container.type == "number") this.container.type = "text";
    }
    // container_change() { this.formatNumber(); }
    // container_keyup() { this.formatNumber(); }
    container_change() { this.checkLength(); }
    container_input() { this.formatNumber(); }

    checkLength() {
        if (this.container.value.replace(/\s/g, "").length > 16) {
            this.container.classList.add("has-error");
            this.container.title = "Překročen maximální počet znaků (16)";
        } else {
            this.container.classList.remove("has-error");
            this.container.title = "";
        }
    }

    formatNumber() {
        // Old swamp ass bullshit
        //// setTimeout(() => {
        //    let val = this.container.value;
        //    let curPos = (this.container.selectionStart || val.length);
        //    curPos -= (val.substring(0, curPos).split(" ").length - 1);
        //    // if (val[curPos] == ' ') curPos++;

        //    val = val.replace(/[^0-9,.]/g, "").replace(/\./g, ",");

        //    let p = val.indexOf(",");

        //    let vint = val;
        //    let vdec = "";
        //    if (p > -1) {
        //        vint = val.substring(0, p);
        //        vdec = val.substring(p + 1);    
        //    }

        //    let nint = "";
        //    let ndec = "";

        //    for(let n = vint.length; n > 0; n -= 3) {
        //        nint = (
        //            vint.substring(n - 3, n)
        //            + (nint ? " " : "")
        //        ) + nint;
        //    }

        //    for(let n = 0; n < vdec.length; n += 3) {
        //        ndec += (
        //            (ndec ? " " : "")
        //            + vdec.substring(n, n + 3)
        //        );
        //    }

        //    let nval = nint + "," + ndec;

        //    this.container.value = nval;

        //    p = 0;
        //    let i = 0;
        //    while (i < nval.length) {
        //        const char = nval[i];
        //        if (char != ' ') p++;
        //        i++;
        //        if (p >= curPos && nval[i] != " ") break;
        //    }
        //    this.container.selectionStart = this.container.selectionEnd = i;

        //// }, 10);

        // Remove any non-numeric characters
        let formattedNumber = this.container.value.replace(/[^0-9.,]/g, "");


        // Get the current cursor position
        const initialCursorPosition = this.container.selectionStart;

        // Replace comma with dot
        formattedNumber = formattedNumber.replace(".", ",");
        let formatted = "";

        // Remove extra dots or commas
        formattedNumber = formattedNumber.replace(/[.,](?=.*[.,])/g, "");

        const parts = formattedNumber.split(",");
        let jumped = false;
         
        // Format whole part
        const wholePart = parts[0];
        for (let i = wholePart.length - 1, count = 0; i >= 0; i--, count++) {
            if (count && count % 3 === 0) {
                // Add space every 3 digits
                formatted = " " + formatted;
                if(wholePart.length % 3 === 1) jumped = true;
            }
            formatted = wholePart[i] + formatted;
        }

        // Combine whole and decimal parts
        formatted += "," + (typeof parts[1] === "undefined" || parts[1] === "" ? "00" : parts[1]);

        this.container.value = formatted;

        // Calculate the new cursor position based on the initial cursor position and the changes in length
        const diff = formatted.length - this.container.value.length;
        let newCursorPosition = initialCursorPosition + diff;

        if (jumped) newCursorPosition++;

        this.container.setSelectionRange(newCursorPosition, newCursorPosition);


        this.checkLength();
    }

    muBindData(srcData: any): void {
        this.container.value = srcData;
        this.formatNumber();
    }

    muFetchData() {
        return (this.container as HTMLInputElement).value.length == 0 || parseFloat((this.container as HTMLInputElement).value.replace(',', '')) == 0 ? "" : this.container.value.replace(/\s/g, "").replace(",", ".");
    }
}